"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
function combineSearches(_a) {
    var recentSearches = _a.recentSearches, savedSearches = _a.savedSearches;
    var savedSearchesLength = savedSearches.length < 3 ? savedSearches.length : 3;
    var recentSearchesLength = recentSearches.length < 5 ? recentSearches.length : 5;
    return __spreadArray(__spreadArray([], savedSearches.slice(0, Math.max(0, 8 - recentSearchesLength)), true), recentSearches.slice(0, Math.max(0, 8 - savedSearchesLength)), true);
}
exports.default = combineSearches;
//# sourceMappingURL=combineSearches.js.map